// Има ли сметката издаден фискален бон, от който да се извади „Дубликат на
// бон" (копие от КЛЕН). Огледало на BE `router_receipt_copy.py`, което налага
// правилото наистина — тук е, за да е ясно ПРЕДИ натискане.
//
// „Фискализирана" = има номер на бон И бонът не е на нулева сума. Сумата на
// бона е поръчаното + бакшиша: сметка с поръчано 0.00 (100 % отстъпка) и
// бакшиш има истински бон с реда за бакшиша — копието ѝ е позволено.
// Сравнението е в цели центове (без шума на float-а). Без бакшиш правилото е
// досегашното `total_amount != 0`.

import type { BillHistory } from "../../../../api/reportsBillsHistory";
import { billTipCentsOf } from "../../../../lib/billTips";
import { parseMoneyToCents } from "../../../../utils/money";

export const hasFiscalReceiptToCopy = (
  bill: Pick<BillHistory, "receipt_number" | "total_amount" | "tip_amount"> | null | undefined,
): boolean => {
  if (!bill) return false;
  if (!(bill.receipt_number || "").trim()) return false;
  const orderedCents = parseMoneyToCents(bill.total_amount) ?? 0;
  return orderedCents + billTipCentsOf(bill) !== 0;
};
